export default __webpack_public_path__ + "static/media/OUEDowntown.jpg?.ffa35058";